import tmhRequest from '@/config/tmhRequest'

export default {

    searchMyCardCount: function (data) {
        return tmhRequest({
            url: '/customer/ispa/mycard/searchmycardcount',
            method: 'post',
            data: data,
        })
    },
    searchMyCardByPage: function (data) {
        return tmhRequest({
            url: '/customer/ispa/mycard/searchmycardbypage',
            method: 'post',
            data: data,
        })
    },

}


// WEBPACK FOOTER //
// ./src/api/ispa/customer/mycard.js